import React from "react";
import { Bar } from "react-chartjs-2";

// Import necessary chart.js components
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register the components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DashboardWidget = ({
  label,
  value,
  percentage,
  percentageType,
  borderColor,
  bgColor,
  textColor,
  graphData,
}) => {
  return (
    <div className={`border-2 ${borderColor} rounded-lg p-4`}>
      <div className="flex items-center mb-2">
        <span
          className={`${bgColor} ${textColor} rounded-full px-2 py-1 text-sm`}
        >
          {percentage} {percentageType}
        </span>
      </div>
      <div className="text-black font-bold">{label}</div>
      <div className="text-4xl font-bold">{value}</div>
      <div className="mt-2 w-full h-25">
        <Bar
          data={{
            labels: graphData.labels,
            datasets: [
              {
                label: "Visitors",
                data: graphData.data,
                backgroundColor: graphData.barColor,
              },
            ],
          }}
          options={{
            plugins: { legend: { display: false } },
            scales: { x: { display: false }, y: { display: false } },
          }}
        />
      </div>
    </div>
  );
};

export default DashboardWidget;
